/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.scopegaps.rpc.PublicScopeGapsService
 */

/* @bend-expect import-missing-runtime-dep */
import { useMemo } from 'react';
import {
  useQuery,
  useLazyQuery,
  useSuspenseQuery,
  QueryHookOptions,
  LazyQueryHookOptions,
  SuspenseQueryHookOptions,
  LazyQueryResultTuple,
  QueryResult,
  UseSuspenseQueryResult,
} from 'data-fetching-client';
import * as References from './PublicScopeGapsService';
import * as Queries from './PublicScopeGapsService.dfc.new';
import type { AdditionalContextArgs } from './PublicScopeGapsService.dfc.new';

type OverrideData<TTuple extends [any, any], TNewData> = [
  TTuple[0],
  Omit<TTuple[1], 'data'> & { data?: TNewData },
];

type LazyQueryResultTupleOverride<
  Response,
  Request extends Record<string, any>,
  DataOverride,
> = OverrideData<LazyQueryResultTuple<Response, Request>, DataOverride>;

type UseGetProductHierarchyQueryReturn<T extends boolean> = Omit<
  QueryResult<
    Record<'result', References.GetProductHierarchyResponseType>,
    References.GetProductHierarchyRequestType
  >,
  'data'
> & {
  data:
    | (T extends true
        ? Record<
            'getProductHierarchy',
            References.GetProductHierarchyResponseType
          >
        : References.GetProductHierarchyResponseType)
    | undefined;
};

export function useGetProductHierarchyQuery<T extends boolean = false>(
  options?: QueryHookOptions<
    Record<'result', References.GetProductHierarchyResponseType>,
    References.GetProductHierarchyRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetProductHierarchyQueryReturn<T> {
  const { data, ...rest } = useQuery(
    Queries.GET_PRODUCT_HIERARCHY_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getProductHierarchy: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetProductHierarchyQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetProductHierarchyQueryReturn<T>;
}

type UseGetProductHierarchyLazyQueryReturn<T extends boolean> =
  LazyQueryResultTupleOverride<
    Record<'result', References.GetProductHierarchyResponseType>,
    References.GetProductHierarchyRequestType,
    T extends true
      ? Record<
          'getProductHierarchy',
          References.GetProductHierarchyResponseType
        >
      : References.GetProductHierarchyResponseType
  >;

export function useGetProductHierarchyLazyQuery<T extends boolean = false>(
  options?: LazyQueryHookOptions<
    Record<'result', References.GetProductHierarchyResponseType>,
    References.GetProductHierarchyRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetProductHierarchyLazyQueryReturn<T> {
  const [getter, { data, ...rest }] = useLazyQuery(
    Queries.GET_PRODUCT_HIERARCHY_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getProductHierarchy: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseGetProductHierarchyLazyQueryReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseGetProductHierarchyLazyQueryReturn<T>;
}

type UseGetProductHierarchySuspenseQueryReturn<T extends boolean> = Omit<
  UseSuspenseQueryResult<
    Record<'result', References.GetProductHierarchyResponseType>,
    References.GetProductHierarchyRequestType
  >,
  'data'
> & {
  data: T extends true
    ? Record<'getProductHierarchy', References.GetProductHierarchyResponseType>
    : References.GetProductHierarchyResponseType;
};

export function useGetProductHierarchySuspenseQuery<T extends boolean = false>(
  options?: SuspenseQueryHookOptions<
    Record<'result', References.GetProductHierarchyResponseType>,
    References.GetProductHierarchyRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetProductHierarchySuspenseQueryReturn<T> {
  const { data, ...rest } = useSuspenseQuery(
    Queries.GET_PRODUCT_HIERARCHY_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      options?.useLegacyFieldNameMode
        ? {
            getProductHierarchy: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetProductHierarchySuspenseQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetProductHierarchySuspenseQueryReturn<T>;
}

type UseGetSatisfyingOptionsQueryReturn<T extends boolean> = Omit<
  QueryResult<
    Record<'result', References.GetSatisfyingOptionsResponseType>,
    References.GetSatisfyingOptionsRequestType
  >,
  'data'
> & {
  data:
    | (T extends true
        ? Record<
            'getSatisfyingOptions',
            References.GetSatisfyingOptionsResponseType
          >
        : References.GetSatisfyingOptionsResponseType)
    | undefined;
};

export function useGetSatisfyingOptionsQuery<T extends boolean = false>(
  options?: QueryHookOptions<
    Record<'result', References.GetSatisfyingOptionsResponseType>,
    References.GetSatisfyingOptionsRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetSatisfyingOptionsQueryReturn<T> {
  const { data, ...rest } = useQuery(
    Queries.GET_SATISFYING_OPTIONS_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getSatisfyingOptions: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetSatisfyingOptionsQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetSatisfyingOptionsQueryReturn<T>;
}

type UseGetSatisfyingOptionsLazyQueryReturn<T extends boolean> =
  LazyQueryResultTupleOverride<
    Record<'result', References.GetSatisfyingOptionsResponseType>,
    References.GetSatisfyingOptionsRequestType,
    T extends true
      ? Record<
          'getSatisfyingOptions',
          References.GetSatisfyingOptionsResponseType
        >
      : References.GetSatisfyingOptionsResponseType
  >;

export function useGetSatisfyingOptionsLazyQuery<T extends boolean = false>(
  options?: LazyQueryHookOptions<
    Record<'result', References.GetSatisfyingOptionsResponseType>,
    References.GetSatisfyingOptionsRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetSatisfyingOptionsLazyQueryReturn<T> {
  const [getter, { data, ...rest }] = useLazyQuery(
    Queries.GET_SATISFYING_OPTIONS_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getSatisfyingOptions: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseGetSatisfyingOptionsLazyQueryReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseGetSatisfyingOptionsLazyQueryReturn<T>;
}

type UseGetSatisfyingOptionsSuspenseQueryReturn<T extends boolean> = Omit<
  UseSuspenseQueryResult<
    Record<'result', References.GetSatisfyingOptionsResponseType>,
    References.GetSatisfyingOptionsRequestType
  >,
  'data'
> & {
  data: T extends true
    ? Record<
        'getSatisfyingOptions',
        References.GetSatisfyingOptionsResponseType
      >
    : References.GetSatisfyingOptionsResponseType;
};

export function useGetSatisfyingOptionsSuspenseQuery<T extends boolean = false>(
  options?: SuspenseQueryHookOptions<
    Record<'result', References.GetSatisfyingOptionsResponseType>,
    References.GetSatisfyingOptionsRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetSatisfyingOptionsSuspenseQueryReturn<T> {
  const { data, ...rest } = useSuspenseQuery(
    Queries.GET_SATISFYING_OPTIONS_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      options?.useLegacyFieldNameMode
        ? {
            getSatisfyingOptions: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetSatisfyingOptionsSuspenseQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetSatisfyingOptionsSuspenseQueryReturn<T>;
}

type UseGetSatisfyingCombosQueryReturn<T extends boolean> = Omit<
  QueryResult<
    Record<'result', References.GetSatisfyingCombosResponseType>,
    References.GetSatisfyingCombosRequestType
  >,
  'data'
> & {
  data:
    | (T extends true
        ? Record<
            'getSatisfyingCombos',
            References.GetSatisfyingCombosResponseType
          >
        : References.GetSatisfyingCombosResponseType)
    | undefined;
};

export function useGetSatisfyingCombosQuery<T extends boolean = false>(
  options?: QueryHookOptions<
    Record<'result', References.GetSatisfyingCombosResponseType>,
    References.GetSatisfyingCombosRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetSatisfyingCombosQueryReturn<T> {
  const { data, ...rest } = useQuery(
    Queries.GET_SATISFYING_COMBOS_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getSatisfyingCombos: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetSatisfyingCombosQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetSatisfyingCombosQueryReturn<T>;
}

type UseGetSatisfyingCombosLazyQueryReturn<T extends boolean> =
  LazyQueryResultTupleOverride<
    Record<'result', References.GetSatisfyingCombosResponseType>,
    References.GetSatisfyingCombosRequestType,
    T extends true
      ? Record<
          'getSatisfyingCombos',
          References.GetSatisfyingCombosResponseType
        >
      : References.GetSatisfyingCombosResponseType
  >;

export function useGetSatisfyingCombosLazyQuery<T extends boolean = false>(
  options?: LazyQueryHookOptions<
    Record<'result', References.GetSatisfyingCombosResponseType>,
    References.GetSatisfyingCombosRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetSatisfyingCombosLazyQueryReturn<T> {
  const [getter, { data, ...rest }] = useLazyQuery(
    Queries.GET_SATISFYING_COMBOS_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getSatisfyingCombos: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseGetSatisfyingCombosLazyQueryReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseGetSatisfyingCombosLazyQueryReturn<T>;
}

type UseGetSatisfyingCombosSuspenseQueryReturn<T extends boolean> = Omit<
  UseSuspenseQueryResult<
    Record<'result', References.GetSatisfyingCombosResponseType>,
    References.GetSatisfyingCombosRequestType
  >,
  'data'
> & {
  data: T extends true
    ? Record<'getSatisfyingCombos', References.GetSatisfyingCombosResponseType>
    : References.GetSatisfyingCombosResponseType;
};

export function useGetSatisfyingCombosSuspenseQuery<T extends boolean = false>(
  options?: SuspenseQueryHookOptions<
    Record<'result', References.GetSatisfyingCombosResponseType>,
    References.GetSatisfyingCombosRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetSatisfyingCombosSuspenseQueryReturn<T> {
  const { data, ...rest } = useSuspenseQuery(
    Queries.GET_SATISFYING_COMBOS_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      options?.useLegacyFieldNameMode
        ? {
            getSatisfyingCombos: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetSatisfyingCombosSuspenseQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetSatisfyingCombosSuspenseQueryReturn<T>;
}

type UseGetSatisfyingCombosBatchQueryReturn<T extends boolean> = Omit<
  QueryResult<
    Record<'result', References.GetSatisfyingCombosBatchResponseType>,
    References.GetSatisfyingCombosBatchRequestType
  >,
  'data'
> & {
  data:
    | (T extends true
        ? Record<
            'getSatisfyingCombosBatch',
            References.GetSatisfyingCombosBatchResponseType
          >
        : References.GetSatisfyingCombosBatchResponseType)
    | undefined;
};

export function useGetSatisfyingCombosBatchQuery<T extends boolean = false>(
  options?: QueryHookOptions<
    Record<'result', References.GetSatisfyingCombosBatchResponseType>,
    References.GetSatisfyingCombosBatchRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetSatisfyingCombosBatchQueryReturn<T> {
  const { data, ...rest } = useQuery(
    Queries.GET_SATISFYING_COMBOS_BATCH_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getSatisfyingCombosBatch: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetSatisfyingCombosBatchQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetSatisfyingCombosBatchQueryReturn<T>;
}

type UseGetSatisfyingCombosBatchLazyQueryReturn<T extends boolean> =
  LazyQueryResultTupleOverride<
    Record<'result', References.GetSatisfyingCombosBatchResponseType>,
    References.GetSatisfyingCombosBatchRequestType,
    T extends true
      ? Record<
          'getSatisfyingCombosBatch',
          References.GetSatisfyingCombosBatchResponseType
        >
      : References.GetSatisfyingCombosBatchResponseType
  >;

export function useGetSatisfyingCombosBatchLazyQuery<T extends boolean = false>(
  options?: LazyQueryHookOptions<
    Record<'result', References.GetSatisfyingCombosBatchResponseType>,
    References.GetSatisfyingCombosBatchRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetSatisfyingCombosBatchLazyQueryReturn<T> {
  const [getter, { data, ...rest }] = useLazyQuery(
    Queries.GET_SATISFYING_COMBOS_BATCH_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getSatisfyingCombosBatch: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseGetSatisfyingCombosBatchLazyQueryReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseGetSatisfyingCombosBatchLazyQueryReturn<T>;
}

type UseGetSatisfyingCombosBatchSuspenseQueryReturn<T extends boolean> = Omit<
  UseSuspenseQueryResult<
    Record<'result', References.GetSatisfyingCombosBatchResponseType>,
    References.GetSatisfyingCombosBatchRequestType
  >,
  'data'
> & {
  data: T extends true
    ? Record<
        'getSatisfyingCombosBatch',
        References.GetSatisfyingCombosBatchResponseType
      >
    : References.GetSatisfyingCombosBatchResponseType;
};

export function useGetSatisfyingCombosBatchSuspenseQuery<
  T extends boolean = false,
>(
  options?: SuspenseQueryHookOptions<
    Record<'result', References.GetSatisfyingCombosBatchResponseType>,
    References.GetSatisfyingCombosBatchRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetSatisfyingCombosBatchSuspenseQueryReturn<T> {
  const { data, ...rest } = useSuspenseQuery(
    Queries.GET_SATISFYING_COMBOS_BATCH_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      options?.useLegacyFieldNameMode
        ? {
            getSatisfyingCombosBatch: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetSatisfyingCombosBatchSuspenseQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetSatisfyingCombosBatchSuspenseQueryReturn<T>;
}
